"use strict";

import EventEmitter from 'eventemitter2';
import Browser from '../util/browser'
import Video from '../video/video';
import VideoCanvas from '../video/videocanvas';

class Header extends EventEmitter{
	constructor($con){
		super();		
		this.$con = $con;
		
		Browser.addResizeHandler(this.scrollresize,this);
		Browser.addResponsiveHandler(this.responsive,this);
		Browser.addScrollHandler(this.scrollresize,this);
		this.responsive();
		this.scrollresize();
	}
	
	start(){
		this.$con.find('h1 .copy1').velocity('stop').velocity({opacity:1},{duration:1800});
		this.$con.find('h1 .copy2').velocity('stop').velocity({opacity:1},{duration:1800,delay:1800});
		this.$con.find('h1 .copy3').velocity('stop').velocity({opacity:1},{duration:1800,delay:3600});
	}
	
	responsive(){
/*
		if(Browser.responsive == 'sp'){
			if(this.video){
				this.video.stop();
			}
		} else {
			//VIDEO
			if(!this.video){
				if(Browser.isiPad){
					this.video = new VideoCanvas( this.$con.find('.vi_movie') );
				} else {
					this.video = new Video( this.$con.find('.vi_movie') );
				}
				
				this.video.on('ready',()=>{
					this.video.play();
				});
				this.video.init();		
			} else {
				this.video.play();
			}
		}
*/
	}
	
	scrollresize(){
		//scroll
		let startY = this.$con.offset().top;
		let endY = startY + this.$con.height();
/*
		if( Browser.scrollY >= startY && Browser.scrollY < endY ){
			if(this.video && !this.video.isPlay){
				this.video.play();
			}
		} else {
			if(this.video && this.video.isPlay){
				this.video.stop();
			}			
		}
*/
		
		//resize
		if(Browser.responsive == 'sp'){
			this.$con.removeAttr('style');
		} else {
			if(Browser.isiPad){
				let wW = Browser.windowWidth;
				let wH = Browser.windowHeight;
				if(wH > wW) wH = wW;
				this.$con.css({height:wH});
			} else {
				this.$con.css({height:Browser.windowHeight});
			}
			
		}
	}
	
}

export default Header;


// WEBPACK FOOTER //
// ./js/section/header.js